export class UserInfo {
    email: string
    first_name: string
    last_name: string
    gender: string
    postal_code: string
    city: string
    phone_number: string
    phone_code: string
    country: string
    address: string
    site_locale: string
    iresa_id: string
    subscribe_newsletter?: boolean
    raw_phone_number?: string
    constructor(
        email: string,
        first_name: string,
        last_name: string,
        gender: string,
        postal_code: string,
        city: string,
        phone_number: string,
        phone_code: string,
        country: string,
        address: string,
        site_locale: string,
        iresa_id: string,
        raw_phone_number?: string,
    ) {
        this.email = email
        this.first_name = first_name
        this.last_name = last_name
        this.gender = gender
        this.postal_code = postal_code
        this.city = city
        this.phone_number = phone_number
        this.phone_code = phone_code
        this.country = country
        this.address = address
        this.site_locale = site_locale
        this.iresa_id = iresa_id
        this.raw_phone_number = raw_phone_number
    }
}